import React, { createContext, useCallback, useContext, useRef } from "react";

interface StickyStateContextValue {
  getState: (key: string) => any | undefined;
  setState: (key: string, value: any) => void;
  clearState: (key: string) => void;
}

const StickyStateContext = createContext<StickyStateContextValue | null>(null);

export const StickyStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const storeRef = useRef<Map<string, any>>(new Map());

  const getState = useCallback((key: string) => {
    return storeRef.current.get(key);
  }, []);

  const setState = useCallback((key: string, value: any) => {
    storeRef.current.set(key, value);
  }, []);

  const clearState = useCallback((key: string) => {
    storeRef.current.delete(key);
  }, []);

  const value: StickyStateContextValue = {
    getState,
    setState,
    clearState,
  };

  return (
    <StickyStateContext.Provider value={value}>
      {children}
    </StickyStateContext.Provider>
  );
};

export const useStickyState = () => {
  const ctx = useContext(StickyStateContext);
  if (!ctx) throw new Error("useStickyState must be used within StickyStateProvider");
  return ctx;
};
